import React from "react";
import styles from "./styles.module.css";
import { Button } from "antd";
import { Link } from "react-router-dom";
import { useSiteAssets, optimized } from "../../../siteAssets";

const tileStyle = (custom) =>
  custom
    ? {
        backgroundImage: `linear-gradient(to top, rgba(15,13,11,0.6), rgba(15,13,11,0.05) 60%), url(${optimized(custom)})`,
      }
    : undefined;

const WearLormami = () => {
  const assets = useSiteAssets();
  return (
    <div className={styles.WearLormamiH}>
      <div className={styles.WearLormamiHT}>
        <div></div>
        <div>
          <p >WEAR LORMAMI</p>
        </div>
        <div></div>
      </div>

      <div className={styles.WearLormamiCat}>
        <div
          className={styles.WearLormamiCatOne}
          style={tileStyle(assets["wear-category-1"])}
        >
          <p>New Arrivals</p>
         <Link to='/new-arrivals'>
         <Button>SHOP NOW</Button>
         </Link>
        </div>
        <div
          className={styles.WearLormamiCatTwo}
          style={tileStyle(assets["wear-category-2"])}
        >
          <p>Upclyled Line</p>
          <Link to='/upcycle'>
          <Button>SHOP NOW</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default WearLormami;